import React from "react";
import { useConfig } from "../../config/ConfigContext";
import Meal from "../Meal/Meal";
import { useMeals } from "../Meal/MealsContext";
import UpdateQuantityPackage from "./UpdateQuantityPackage";
import { formatPrice } from "../../utils/formatPrice";

const Package = ({ name }) => {
  const { meals } = useMeals();
  const config = useConfig();
  const packageMeal =
    meals.find((meal) => meal.fields["Name"] === name) ?? null;

  const isLoading = meals.length === 0;

  return (
    <>
      <div id={name} className="px-5">
        <div className="flex justify-between max-w-xl items-center m-auto mb-4">
          <h2 className="text-xl md:text-2xl text-center uppercase text-secondary">
            {name}
          </h2>
          {packageMeal ? (
            <div className="flex items-center">
              <p className="mr-2 text-md md:text-lg text-primary">
                {formatPrice(packageMeal.fields[config.itemPriceFieldTTC])} €
              </p>
              <UpdateQuantityPackage packageMeal={packageMeal} />
            </div>
          ) : (
            <p className="text-md md:text-lg text-red-500">Package not found</p>
          )}
        </div>

        <div className="grid grid-cols-1 max-w-xl m-auto">
          {isLoading ? (
            <div className="w-full max-w-xl max-h-xl h-80 bg-gray-400 opacity-30 rounded"></div>
          ) : packageMeal && packageMeal.fields["meals"] ? (
            packageMeal.fields["meals"].map((meal) => (
              <Meal key={meal.id} meal={meal} packageName={name} />
            ))
          ) : (
            <p className="text-center text-gray-500">
              No meals in this package
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default Package;
